;(function() {
  'use strict'

  feedService.$inject = ["$q", "activityStreamsResource", "userService", "glUtils"];
  angular.module('core.services').factory('feedService', feedService)

  // --------------------

  /* @ngInject */
  function feedService($q, activityStreamsResource, userService, glUtils) {
    var states = {
      IDLE: 'idle',
      NOTLOGGEDIN: 'notLoggedIn',
      LOADING: 'loading',
      NONE: 'none',
      READY: 'ready',
      ERROR: 'error',
    }

    var verbColors = {
      reply: 'blue',
      communicate: 'blue',
      review: 'blue',
      register: 'orange',
      follow: 'orange',
      'survey-response': 'green',
    }

    var verbIcons = {
      reply: 'gi-communicate',
      communicate: 'gi-communicate',
      review: 'gi-review',
      register: 'gi-plus-one',
      follow: 'gi-person-add',
      'survey-response': 'gi-survey',
    }

    return {
      get: get,
      list: list,
    }

    // --------------------

    function get(options) {
      var feed = {
        limit: options.limit,
        state: states.IDLE,
        refresh: refresh,
      }

      function refresh() {
        feed.state = states.LOADING
        if (!options.element && !userService.loggedIn()) {
          feed.state = states.NOTLOGGEDIN
          return
        }
        list(options).then(
          function(data) {
            feed.data = data
            feed.state = data.length === 0 ? states.NONE : states.READY
          },
          function() {
            feed.state = states.ERROR
          }
        )
      }
      refresh()

      return feed
    }

    function list(options) {
      return $q(function(resolve, reject) {
        options = options || {}
        var data = {
          top: options.top || 20,
          skip: options.skip || 0,
          orderby: 'popularityIndex desc',
        }
        if (options.element) {
          // element feed
          data.filter = glUtils.formatUnicorn(
            'actor.id eq {element} or object.id eq {element} or target.id eq {element}',
            {
              element: options.element,
            }
          )
        } else {
          // my feed
          data.followedBy = userService.get().id
        }
        activityStreamsResource
          .get(data)
          .success(function(res, feed) {
            addExtras(feed)
            resolve(feed)
          })
          .error(function(err) {
            reject(err)
          })
      })
    }

    function addExtras(feed) {
      _.each(feed, function(item) {
        item.extras = {}
        item.extras.color = verbColors[item.verb] || 'orange'
        item.extras.icon = verbIcons[item.verb] || 'gi-glow'
        item.extras.summary = makeSummary(item)
      })
    }

    function makeSummary(item) {
      var keys = ['target', 'object', 'actor']
      var summary = item.summary
      // bold the actor name
      summary = summary.replace(
        item.actor.displayName,
        '<b>' + item.actor.displayName + '</b>'
      )
      // replace links
      _.each(keys, function(key) {
        if (item[key] === null || item[key].objectType !== 'element') {
          return
        }
        var pattern = new RegExp('{(.+?):' + key + '}', 'g')
        summary = summary.replace(
          pattern,
          '<a ng-click="viewElement($event, item, \'' +
            key +
            "', '" +
            (item[key].elementType || 'element') +
            '\')">$1</a>'
        )
      })
      // replace everything else
      var patternElse = /{(.+?):(actor|object|target)}/g
      summary = summary.replace(patternElse, '<b>$1</b>')
      return summary
    }
  }
})()
